import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { oid, date } from '@/helpers/mongoHelpers'
import useCommon from '@/views/organization/useCommon'
import useCommonLibrary from '../useCommonLibrary'

export default function useLibraryAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createDocument, sendDocumentCreatedEmail } = useCommonLibrary()
  const { formatDate } = useCommon()
  const isSubmitting = ref(false)

  async function create(data, documentFile) {
    isSubmitting.value = true

    try {
      const payload = {}

      if (data.nombre?.value) payload.nombre = data.nombre.value
      if (data.tipoDocumento?.value) payload.tipoDocumento = data.tipoDocumento.value
      if (data.tematica?.value) payload.tematica = data.tematica.value
      if (data.responsable?.value) payload.responsable = oid(data.responsable.value)
      if (data.clientes?.value?.length) payload.clientes = data.clientes.value.map(c => oid(c))
      if (data.observaciones?.value) payload.observaciones = data.observaciones.value
      if (data.fechaProximaRevision?.value) payload.fechaProximaRevision = date(formatDate(data.fechaProximaRevision.value))

      const file = documentFile?.name ? documentFile : null

      const docId = await createDocument(payload, file)

      // Send email to responsable
      if (data.responsable?.value) {
        sendDocumentCreatedEmail(docId, {
          nombre: data.nombre.value,
          tipoDocumento: data.tipoDocumento.value,
          versionActual: 1,
          fechaProximaRevision: data.fechaProximaRevision.value,
        }, data.responsable.value)
      }

      showSuccessMessage(i18n.t('biblioteca.created_success'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('biblioteca.error_create'))
    } finally {
      router.push({ name: 'organization-library-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    isSubmitting,
  }
}
